// Blocked Twitch terms dialog for the library page

import React from 'react';
import BlockedTwitchTermsContent from '../moderation/BlockedTwitchTermsContent';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';

const BlockedTwitchTermsDialog: React.FC<LibraryDialogOutletProps> = ({
  user,
  dialog,
  censorship,
  setDialog,
}) => {
  if (!user) {
    return null;
  }

  return (
    <Dialog
      open={dialog === 'blocked-twitch-terms'}
      onOpenChange={(nextOpen) =>
        setDialog(nextOpen ? 'blocked-twitch-terms' : null)
      }
    >
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Blocked Terms on Twitch</DialogTitle>
          <DialogDescription>
            Import public blocked terms from your Twitch channel.
          </DialogDescription>
        </DialogHeader>
        <BlockedTwitchTermsContent
          modSettings={censorship.modSettings}
          syncStatus={censorship.syncStatus}
          onTwitchTermsBlockedToggle={censorship.handleTwitchTermsBlockedToggle}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BlockedTwitchTermsDialog;
